var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-layout"},[(_vm.navbarActive)?_c('navbar'):_vm._e(),_vm._v(" "),_c('main',{staticClass:"py-4"},[_c('child')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }